<script setup lang="ts">
import { ref } from "vue";

const min = ref(1);
const max = ref(10);
const value = ref<number | null>(null);

function generateRandom() {
  const low = Number(min.value);
  const high = Number(max.value);
  const start = Math.min(low, high);
  const end = Math.max(low, high);
  value.value = Math.floor(Math.random() * (end - start + 1)) + start;
}
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Random number banao</h2>
      <p class="text-sm text-slate-600">Do number do, phir dekho Python un ke beech me koi aik number chun leta hai.</p>
    </div>

    <div class="mt-4 grid grid-cols-2 gap-3">
      <input v-model="min" type="number" class="rounded-xl border border-slate-200 px-3 py-2 text-sm" placeholder="1">
      <input v-model="max" type="number" class="rounded-xl border border-slate-200 px-3 py-2 text-sm" placeholder="10">
    </div>

    <pre class="mt-4 overflow-x-auto rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100"><code>import random
print(random.randint({{ min }}, {{ max }}))</code></pre>

    <button type="button" class="mt-4 rounded-full bg-slate-950 px-4 py-2 text-sm font-medium text-white" @click="generateRandom">
      Number banao
    </button>

    <div v-if="value !== null" class="mt-4 rounded-2xl bg-emerald-50 p-4 ring-1 ring-emerald-100">
      <p class="text-xs font-semibold uppercase tracking-wide text-emerald-700">Output</p>
      <p class="mt-2 text-sm font-medium text-emerald-900">{{ value }}</p>
    </div>
  </section>
</template>
